import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const deleteReasonCodeSlice = createApi(`DeleteReasonCodeSlice`,"DELETE");

const DeleteReasonCodeSlice = createSlice({
  name: 'DeleteReasonCodeSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteReasonCodeSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteReasonCodeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteReasonCodeSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteReasonCodeSlice.reducer;